import { useLanguage } from "@/context/LanguageContext";

const IMG_1 =
  "https://images.unsplash.com/photo-1633767979501-6225d151ba70?crop=entropy&cs=srgb&fm=jpg&q=65&w=900";
const IMG_2 =
  "https://images.unsplash.com/photo-1682289869404-be84fe0cdc0c?crop=entropy&cs=srgb&fm=jpg&q=65&w=700";
const IMG_3 =
  "https://images.unsplash.com/photo-1583364493238-248032147fbd?crop=entropy&cs=srgb&fm=jpg&q=65&w=700";

export default function About() {
  const { t } = useLanguage();
  const a = t.about;

  return (
    <section
      id="about"
      className="relative overflow-hidden bg-[#FAF7F2] pt-14 pb-20 md:pt-16 md:pb-28"
      data-testid="about-section"
    >
      {/* Decorative dot grid */}
      <div
        className="pointer-events-none absolute -left-12 top-12 hidden h-44 w-44 opacity-40 md:block"
        style={{
          backgroundImage:
            "radial-gradient(#0A0A0A 1px, transparent 1px)",
          backgroundSize: "12px 12px",
        }}
        aria-hidden="true"
      />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-6 md:grid-cols-12 md:px-10 md:gap-16">
        {/* Left: image collage */}
        <div className="relative md:col-span-6">
          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-3xl">
            <img
              src={IMG_1}
              alt="Horseback rider on Isabela beach"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 -right-2 hidden h-48 w-40 overflow-hidden rounded-2xl ring-8 ring-[#FAF7F2] md:block lg:h-56 lg:w-48">
            <img
              src={IMG_2}
              alt="Kids at the farm"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -left-4 top-10 hidden h-40 w-32 overflow-hidden rounded-2xl ring-8 ring-[#FAF7F2] md:block lg:h-44 lg:w-36">
            <img
              src={IMG_3}
              alt="Snorkeling reef"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        {/* Right: text */}
        <div className="md:col-span-6 md:pl-6 lg:pl-10">
          <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.32em] text-[#FF5533]">
            {a.eyebrow}
          </p>
          <h2
            className="text-4xl leading-[1.05] tracking-tight md:text-5xl lg:text-6xl"
            style={{ fontFamily: "Fraunces, serif" }}
            data-testid="about-title"
          >
            {a.title}
          </h2>

          <p className="mt-7 text-[17px] leading-relaxed text-[#1A1A1A]/85">
            {a.body_1}
          </p>
          <p className="mt-5 text-[17px] leading-relaxed text-[#1A1A1A]/85">
            {a.body_2}
          </p>

          {/* Stats */}
          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-[#E5DACC] pt-8">
            <div>
              <div
                className="text-3xl tracking-tight text-[#FF5533] md:text-4xl"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                {a.stat_1_value}
              </div>
              <p className="mt-1 text-[11px] uppercase tracking-wider text-[#4A4A4A]">
                {a.stat_1_label}
              </p>
            </div>
            <div>
              <div
                className="text-3xl tracking-tight text-[#FF5533] md:text-4xl"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                {a.stat_2_value}
              </div>
              <p className="mt-1 text-[11px] uppercase tracking-wider text-[#4A4A4A]">
                {a.stat_2_label}
              </p>
            </div>
            <div>
              <div
                className="text-3xl tracking-tight text-[#FF5533] md:text-4xl"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                {a.stat_3_value}
              </div>
              <p className="mt-1 text-[11px] uppercase tracking-wider text-[#4A4A4A]">
                {a.stat_3_label}
              </p>
            </div>
          </div>

          <a
            href="#reviews"
            data-testid="about-cta"
            className="mt-10 inline-flex items-center gap-2 rounded-full border border-[#0A0A0A]/15 bg-white px-6 py-3 text-sm font-semibold text-[#0A0A0A] transition-all hover:-translate-y-0.5 hover:border-[#FF5533] hover:text-[#FF5533]"
          >
            {a.cta} →
          </a>
        </div>
      </div>
    </section>
  );
}
